// import MintUI from 'mint-ui'
import Vue from 'vue'
import { Toast } from 'mint-ui'
import { Checklist } from 'mint-ui'
import { Cell } from 'mint-ui'
import { Swipe, SwipeItem } from 'mint-ui'
import { Tabbar, TabItem } from 'mint-ui'
import { TabContainer, TabContainerItem } from 'mint-ui'
import { Button} from 'mint-ui'
import { MessageBox  } from 'mint-ui'
import { DatetimePicker, Popup, picker} from 'mint-ui'
// import { DatetimePicker,Toast,Popup,Picker  } from 'mint-ui';
import { Picker } from 'mint-ui'
import { Switch } from 'mint-ui'
import { Field } from 'mint-ui';
import 'mint-ui/lib/style.css'
import { Radio } from 'mint-ui';
import { Badge } from 'mint-ui';
Vue.component(Radio.name, Radio);
// MessageBox.prompt(message, title)
// Vue.component(MessageBox.prompt(message, title))

Vue.component(Switch.name, Switch)
// Vue.component(Switch.name, Switch)
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)
Vue.component(TabContainer.name, TabContainer)
Vue.component(Button.name, Button)
Vue.component(Cell.name, Cell)
Vue.component(TabContainerItem.name, TabContainerItem)
Vue.component(Cell.name, Cell)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Checklist.name, Checklist)
Vue.component(Toast)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(Tabbar.name, Tabbar)
Vue.component(TabItem.name, TabItem) // 引入icon自定义svg-icon图标
Vue.component(Field.name, Field);
Vue.component(Badge.name, Badge);

// Vue.use(MintUI);



// WEBPACK FOOTER //
// ./src/splitmint.js